import http from "../../http-common";

export default class MyPrograms {
  getMyPrograms(userId: string) {
    let url = `/events/myprogram/${userId}`;

    return http.get(url);
  }
}